import Vue from "vue";
import draggable from 'vuedraggable';
import VueContext from 'vue-context';
import AlphanumericEncoder from 'alphanumeric-encoder';
import { romanToArab, arabToRoman, isValidArab, isValidRoman } from 'roman-numbers';
const encoder = new AlphanumericEncoder()
import { v4 as uuidv4 } from 'uuid';
Vue.component("annex-notes-editor", {
	props: {
		value: {
			required: false,
			type: Array,
			default: null
		},
		list: {
			required: false,
			type: Array,
			default: null
		},
		additionalClasses: {
			required: false,
			type: String,
			default: null
		},
		level: {
			required: false,
			type: Number,
			default: 0
		},
		showMenu: {
			required: false,
			type: Boolean,
			default:false
		}
	},
	components: {
		draggable,
		VueContext
	},
	data() {
		return {
			data: this.list,
			hasSelected: false,
			currentNote: null,
			showFormModal: false
		};
	},
	methods: {
		emitter: function (value) {
			this.$emit("custom");
			
			this.$emit("update:value", value);

		},
		contextClick: function (event, data, orientation) {

		},
		rearrange: function (type) {

		},
		collapse: function (note) {
			if (note.isOpen == null || typeof note.isOpen == 'undefined') {
				note.isOpen = true;
			}

		},
		onClick: function (note) {
			if (this.currentNote && this.currentNote != note) {
				this.currentNote.isSelected = false;
			}

			this.currentNote = note;
			this.currentNote.isSelected = true;
			this.hasSelected = true;
			console.log(this.currentNote)
		},
		onContextOpen: function (event, data, top, left) {

			this.currentNote = data;
		},
	},
	mounted() {
	},
	computed: {
		referenceStyle: function () {
			let returnValue = '';
			let margin = (this.level * 40);
			returnValue += 'margin-left:' + margin + 'px;'
			return returnValue;
		},
		dragOptions() {
			return {
				animation: 0,
				group: "node",
				disabled: false
			};
		},
		
		// this.value when input = v-model
		// this.list  when input != v-model
		realValue() {
			return this.value ? this.value : this.list;
		},
		
	},
	template: `
		<div :class="additionalClasses">
			<div class="columns" v-if="showMenu">
				<div class="column">
					<div class="buttons has-addons">
						<b-field class="">
							<b-dropdown aria-role="list" :disabled="!hasSelected">
								<template #trigger="{ active }">
									<b-button
										size="is-small"
										label="Add"
										icon-right="plus" />
								</template>
								<b-dropdown-item aria-role="listitem" @click="contextClick('add', null, 'Above')">Above</b-dropdown-item>
								<b-dropdown-item aria-role="listitem" @click="contextClick('add', null, 'Below')">Below</b-dropdown-item>
								<b-dropdown-item aria-role="listitem" @click="contextClick('add', null, 'Child')">Child</b-dropdown-item>
								<b-dropdown-item aria-role="listitem" @click="contextClick('add', null, 'NoteAbove')">Note Above</b-dropdown-item>
								<b-dropdown-item aria-role="listitem" @click="contextClick('add', null, 'NoteBelow')">Note Below</b-dropdown-item>
								<b-dropdown-item aria-role="listitem" @click="contextClick('add', null, 'ChildNote')">Child Note</b-dropdown-item>

							</b-dropdown>
							<b-button size="is-small"
								icon-left="minus"  @click="contextClick('edit', null)" :disabled="!hasSelected">
									Edit
							</b-button>
							<b-button size="is-small"
								icon-left="trash-alt" @click="contextClick('delete')"  :disabled="!hasSelected">
									Delete
							</b-button>
							 <b-dropdown aria-role="list" :disabled="!hasSelected">
								<template #trigger="{ active }">
									<b-button
										size="is-small"
										label="Arrange Numbering"
										icon-right="arrow-down-short-wide" />
								</template>
								<b-dropdown-item aria-role="listitem" @click="rearrange('arab')">Arab</b-dropdown-item>
								<b-dropdown-item aria-role="listitem" @click="rearrange('alphaupper')">Alphabetic Upper</b-dropdown-item>
								<b-dropdown-item aria-role="listitem" @click="rearrange('alphalower')">Alphabetic Lower</b-dropdown-item>
								<b-dropdown-item aria-role="listitem" @click="rearrange('romanupper')">Roman Upper</b-dropdown-item>
								<b-dropdown-item aria-role="listitem" @click="rearrange('romanlower')">Roman Lower</b-dropdown-item>
							</b-dropdown>  
						</b-field>
					</div>
				</div>
			</div>
			 
			<draggable class="dragArea" v-model="data" tag="ul"  :group="{ name: 'g1' }" @input="emitter" @choose="onClick">
				<li  v-for="note in data" :data-id="note.id" :key="note.id" class="row is-full"
					:class="{ 'has-background-info-light' : note.isSelected }" @click="onClick(note)"
					@contextmenu.prevent="$refs.notesmenu.open($event, note)"
					>
					
						<div class="columns mb-0 pt-1 pl-0 pb-1 pr-0">
							<div class="column column-note-reference-number pl-0 pr-0 pt-1 pb-0 ">
								  
								  <b-button  v-if="note.children && note.children.length > 0" 
									  class="is-white"
									  @click="note.isOpen = !note.isOpen" size="is-small"
											:icon-left="note.isOpen ? 'chevron-down' : 'chevron-up'"
											:aria-controls="'childrenNote'+ note.id"
											>
								 </b-button>
								 <div v-else>
									&nbsp;
								 </div>
							</div>
							<div class="column column-note-reference-number  pl-0 pr-2 pt-2 pb-2" :style="referenceStyle">{{ note.referenceNumber }}</div>
							<div :class="{'column': true, 'column-note-text': true, 'p-2': true, 'is-reciprocity': note.isReciprocityNote}" v-html="note.text"></div>
						</div>
						<b-collapse  :open="true" v-model="note.isOpen" :aria-id="'childrenNote' + note.id">
							<annex-notes-editor :show-menu="false" :level="level + 1" :list="note.children"></annex-notes-editor>
						
						</b-collapse>
					
						<div v-if="note.items.length > 0" class="column" :style="referenceStyle">
							<note-items :note="note"></note-items>
						</div>
						<div v-if="note.footer" class="row is-full">
							<div class="columns mb-0">
								<div class="column column-note-reference-number" :style="referenceStyle">&nbsp;</div>
								<div class="column column-note-text p-2" v-html="note.footer"></div>
							</div>
						</div>
					
				</li>
			</draggable>
			<vue-context ref="notesmenu" v-slot="{ data }" @open="onContextOpen">
				<li class="v-context__sub">
					<a href="#" >Add</a>
					<ul class="v-context">
						<li>
							<a @click.prevent="contextClick('add', data, 'above')">Above</a>
						</li>
						<li>
							<a @click.prevent="contextClick('add', data, 'below')">Below</a>
						</li>
						<li>
							<a @click.prevent="contextClick('add', data, 'child')">Child</a>
						</li>
                        <li>
							<a @click.prevent="contextClick('add', data, 'NoteAboce')">Note Above</a>
						</li><li>
							<a @click.prevent="contextClick('add', data, 'NoteBelow')">Note Below</a>
						</li><li>
							<a @click.prevent="contextClick('add', data, 'ChildNote')">Child Note</a>
						</li>
					</ul>
				</li>
				<li>
					<a href="#" @click.prevent="contextClick('edit', data)">Edit</a>
				</li>
				<li>
					<a href="#" @click.prevent="contextClick('delete', data)">Delete</a>
				</li>
			</vue-context>

			<b-modal id="formModal" width="900px" parent="coverageModal" ref="formModal" v-model="showFormModal" #default="props" :can-cancel="['x']">
				<div class="modal-card" style="width: auto">
					<header class="modal-card-head">
						<p class="modal-card-title">
							Entity
						</p>
					</header>
					<section class="modal-card-body">
						<div class="columns">
							<div class="column">
								   <b-field label="Reference Number">
										<b-input v-if="!isEditing" v-model="viewModel.referenceNumber"></b-input>
										<b-input v-else v-model="viewModel.updatedReferenceNumber"></b-input>

								   </b-field>
							</div>
							<div class="column is-half">
								   <b-field label="Name">
										<b-input v-if="!isEditing" v-model="viewModel.name"></b-input>
										<b-input v-else v-model="viewModel.updatedName"></b-input>
								   </b-field>
							</div>
							<div class="column">
								   <b-field label="Original name">
										<b-input v-if="!isEditing" v-model="viewModel.originalName"></b-input>
										<b-input v-else v-model="viewModel.updatedOriginalName"></b-input>
								   </b-field>
							</div>
						</div>
					</section>
					<footer class="modal-card-foot buttons is-right">
						<b-button label="Save" @click="update"></b-button>
						<b-button label="Cancel" @click="props.close"></b-button>

					</footer>
				 </div>
			</b-modal>
		</div>
	`
});